import { makeStyles } from "@material-ui/styles";

export const useRoleStyles: any = makeStyles(
  (theme: { [key: string]: any }) => ({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },
    permissionHeading: {
      fontSize: "1.5em",
      fontWeight: "bold",
      paddingLeft: ".50em",
      paddingTop: "1em",
    },
    rolePermissionHeading: {
      border: "1px solid #e6e6e6",
    },
    divStyle: {
      paddingLeft: "1em",
      paddingRight: "1em",
      paddingTop: "1em",
    },
    listItemStyle: {
      padding: "5px 5px 5px 0.4em",
    },
    listItemTextStyle: {
      fontSize: "0.813rem",
      fontWeight: "lighter",
    },
    buttonGridStyle: {
      paddingTop: "1em",
      paddingLeft: "8em",
    },
    checkBoxStyle: {
      height: "40em",
      overflow: "auto",
      marginTop: "10px",
    },
    iconStyle: { fontSize: "12px", padding: "0px" },
    SearchInput: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },
    editIconMargin: {
      marginRight: theme.spacing(1),
       backgroundColor: "white",//"#8bc34a",
      boxShadow: "none",
      borderRadius: "0.3em",
      "&:hover": {
        backgroundColor:"#717d8a",
      }
    },
    editIcon: {
      width: ".90em",
      height: ".90em",
      color:"#3d5a79 !important",
    },
    fieldLabelStyles:{
      paddingBottom:"1em",
      fontWeight:"bold"
    },
    fieldSpace:{
      paddingTop:"3em",
      paddingLeft:"3em", 
      paddingRight:"3em",
       paddingBottom:"3em"
    },
    buttonPosition:{
      paddingTop:"2.5em"
    },
    buttonStyle:{
      paddingTop: "3em",
      textAlign:"right"
    },
  })
);
